import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

function ModulesLoading() {
  return (
    <div className="h-screen w-screen flex flex-col gap-4 items-center justify-center">
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
    </div>
  );
}

export { ModulesLoading };
